import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import * as yup from 'yup';
import { useFormik } from 'formik';

const CreateCustomer = (props) => {
  const { is_customer_modal_open,
    handleCustomerModal,
    is_loading,
    handleCustomerSubmit,
    handleCustomerUpdate,
    c_action,
    customer_id,
    selected_data,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleCustomerCloseModalChange = () => {
    formik.resetForm();
    handleCustomerModal(false);
  };

  const validationSchema = yup.object().shape({
    company_name: yup.string().trim().required('Company Name is required.'),
  });

  const onSubmit = async (values) => {
    let res_create, res_update;

    if (c_action === "UPDATE") {
      const payload = { customer_id, updated_data: values };
      res_update = await handleCustomerUpdate(payload);
    } else {
      res_create = await handleCustomerSubmit(values);
    }

    if (
      (res_create || res_update) &&
      !(res_create?.error || res_update?.error)
    ) {
      formik.resetForm();
      handleCustomerModal(false);
      window.location.reload()
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: c_action === "UPDATE" ? selected_data.company_name : '',
      special_instructions: c_action === "UPDATE" ? (selected_data.special_instructions || '') : '',
    },
    validationSchema: validationSchema,
    onSubmit,
  });

  return (
    <Dialog
      fullScreen={fullScreen}
      open={is_customer_modal_open}
      onClose={handleCustomerCloseModalChange}
      aria-labelledby="responsive-dialog-title"
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        '& .MuiDialog-paper': {
          width: '400px'
        },
      }}
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {(c_action === 'UPDATE' && 'Update Customer') || (c_action === 'CREATE' && 'Create Customer')}
        <IconButton size="medium" onClick={handleCustomerCloseModalChange}>
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: '6px' }}>
          <TextField
            label="Company Name"
            variant="outlined"
            size="small"
            name="company_name"
            value={formik.values.company_name}
            onChange={formik.handleChange('company_name')}
            onBlur={formik.handleBlur('company_name')}
            error={formik.touched.company_name && Boolean(formik.errors.company_name)}
            helperText={formik.touched.company_name && formik.errors.company_name}
            fullWidth
          />
          <TextField
            label="Special Instructions"
            variant="outlined"
            size="small"
            name="special_instructions"
            value={formik.values.special_instructions}
            onChange={formik.handleChange('special_instructions')}
            onBlur={formik.handleBlur('special_instructions')}
            error={formik.touched.special_instructions && Boolean(formik.errors.special_instructions)}
            helperText={formik.touched.special_instructions && formik.errors.special_instructions}
            fullWidth
            multiline
            rows={3}
          />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          padding: '8px 24px 24px 24px',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          color="error"
          onClick={handleCustomerCloseModalChange}
          sx={{ borderColor: "#ff6100", color: "#4c4e52" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{ backgroundColor: "#ff6100" }}
          disabled={is_loading}
        >
          {(c_action === 'UPDATE' && 'Update') || (c_action === 'CREATE' && 'Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCustomer;
